export const MAKERLOG_SUBMIT = 'MAKERLOG_SUBMIT';
export const MAKERLOG_SUBMIT_PENDING = 'MAKERLOG_SUBMIT_PENDING';
export const MAKERLOG_SUBMIT_FULFILLED = 'MAKERLOG_SUBMIT_FULFILLED';
export const MAKERLOG_SUBMIT_REJECTED = 'MAKERLOG_SUBMIT_REJECTED';
